import React from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import SurveysButton from "components/card/SurveysButton";
import useAuth from "hooks/auth/useAuth";
import useSurveyVotes from "hooks/surveys/useSurveyVotes";

const SurveyCard = ({ survey }) => {
  const { currentUser } = useAuth();
  const { handleVote } = useSurveyVotes();
  const router = useRouter();
  const givenTime = new Date(survey?.endOfVoting);
  const now = new Date();
  const isPast = givenTime < now;

  return (
    <div
      style={{ fontFamily: "Noto Sans Armenian" }}
      className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 p-4 sm:p-5 md:p-6 rounded-2xl md:rounded-[28px] bg-white dark:bg-[#0c0a1f] border border-slate-100 dark:border-white/10 shadow-[0_4px_24px_rgba(0,0,0,0.03)] hover:shadow-lg transition-all duration-300 w-full h-full"
    >
      <div className="flex flex-row gap-3 sm:gap-4 md:gap-6 w-full items-center min-w-0">
        <div className="w-[72px] h-[72px] sm:w-[90px] sm:h-[90px] md:w-[130px] md:h-[130px] shrink-0 overflow-hidden rounded-xl sm:rounded-[20px]">
          <Image
            width={130}
            height={130}
            src={survey.image || "/default_video.webp"}
            alt="person"
            priority
            className="object-cover w-full h-full"
          />
        </div>
        <div className="flex flex-col flex-1 gap-2 sm:gap-3 justify-between min-w-0">
          <div
            onClick={() => router.push(`/surveys/${survey.id}`)}
            className="cursor-pointer"
          >
            <h3 className="text-slate-900 dark:text-white text-sm sm:text-base md:text-lg font-bold line-clamp-2 leading-snug hover:text-[#0033FF] transition-colors break-words">
              {survey?._highlightResult?.title?.value ? (
                <span
                  className="highlighted"
                  dangerouslySetInnerHTML={{
                    __html: survey?._highlightResult?.title?.value || "",
                  }}
                />
              ) : (
                survey.title
              )}
            </h3>
          </div>
          <div className="w-full flex justify-end">
            <SurveysButton
              isDisabled={isPast || survey.type === "finished"}
              currentUser={currentUser}
              survey={survey}
              disabledText={
                survey.choices?.find((item) => item.id === survey.result)?.value
              }
              onChange={(state) => {
                handleVote(survey.id, currentUser?.uid, state);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyCard;
